import VueSocialSharing from 'vue-social-sharing'
import { app } from './main-app'

app.use(VueSocialSharing)
